import { render } from "./WavesShape.vue?vue&type=template&id=a6cf0766"
import script from "./WavesShape.vue?vue&type=script&lang=js"
export * from "./WavesShape.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/coastal-watchers-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__